import { SearchModelBase } from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class OtOpContainerListItem extends SearchModelBase {
    id: number = 0;
    genMainId: number = 0;
    containerNo: string = '';
    conType: string = '';
    refNo: string = '';
    mblNo: string = '';
    loadingPort: string = '';
    dischargePort: string = '';
    placeOfDelivery: string = '';
    location: string = '';

    eta: string | null = null;
    fromEta: string | null = null;
    toEta: string | null = null;

    //Booking
    bookingDate: string | null = null;
    fromBookingDate: string | null = null;
    toBookingDate: string | null = null;

    //Container Dispatched
    ord: string | null = null;
    fromOrd: string | null = null;
    toOrd: string | null = null;

    //Gate In
    inDate: string | null = null;
    fromInDate: string | null = null;
    toInDate: string | null = null;

    //Vessel Departure
    loadDate: string | null = null;
    fromLoadDate: string | null = null;
    toLoadDate: string | null = null;

    //Vessel Departure
    atd: string | null = null;
    fromAtd: string | null = null;
    toAtd: string | null = null;

    //Vessel Arrival
    ata: string | null = null;
    fromAta: string | null = null;
    toAta: string | null = null;

    //Vessel Arrival
    unloadDate: string | null = null;
    fromUnloadDate: string | null = null;
    toUnloadDate: string | null = null;

    //Carrier Release
    carrierRls: string | null = null;
    fromCarrierRls: string | null = null;
    toCarrierRls: string | null = null;

    //Customs Release
    customsRls: string | null = null;
    fromCustomsRls: string | null = null;
    toCustomsRls: string | null = null;

    //Rail Departure
    rAtd: string | null = null;
    fromRAtd: string | null = null;
    toRAtd: string | null = null;

    //Inland ETA
    inlandEta: string | null = null;
    fromInlandEta: string | null = null;
    toInlandEta: string | null = null;

    //Rail Arrival
    rAta: string | null = null;
    fromRAta: string | null = null;
    toRAta: string | null = null;

    //Last Free Day
    lastFreeDay: string | null = null;
    fromLastFreeDay: string | null = null;
    toLastFreeDay: string | null = null;

    //Pickup Avilable
    puDate: string | null = null;
    fromPuDate: string | null = null;
    toPuDate: string | null = null;

    //Pickup Container
    outDate: string | null = null;
    fromOutDate: string | null = null;
    toOutDate: string | null = null;

    //Actual Delivery
    dcDate: string | null = null;
    fromDcDate: string | null = null;
    toDcDate: string | null = null;

    //Emtpy Return
    emptyReturn: string | null = null;
    fromEmptyReturn: string | null = null;
    toEmptyReturn: string | null = null;

    vessel: string = '';
    voyage: string = '';

    etd: string | null = null;
    fromEtd: string | null = null;
    toEtd: string | null = null;

    trType: string = '';
    trStatus: string = '';
    trStatusDesc: string = '';

    trDate: string | null = null;
    fromTrDate: string | null = null;
    toTrDate: string | null = null;
    
    //Track Event
    lastEvent: string = '';
    lastEventDate: string | null = null;

    // Mbl
    status: string = '';
    recognized: string = '';
    prepBy: string = '';
    mblCreatedDate: string | null = null;
    frommblCreatedDate: string | null = null;
    tomblCreatedDate: string | null = null;
    mblCreateBy: string = '';
    trCreatedBy: string = '';
    
    hblNo: string = '';
    customerName: string = '';

    confirmDate: string | null = null;
    fromConfirmDate: string | null = null;
    toConfirmDate: string | null = null;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0,  text: 'S', width: 30, dataIndex: 'status' }),
        XCol.Create({ col: 1,  text: 'R.Date', width: 80, dataIndex: 'confirmDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, visible: true }),
        XCol.Create({ col: 2,  text: 'Prep. By', width: 60, dataIndex: 'prepBy', defaultColumnFocus: true }),
        XCol.Create({ col: 3,  text: 'Container #', width: 100, dataIndex: 'containerNo', defaultColumnFocus: true }),
        XCol.Create({ col: 4,  text: 'Type', width: 60, dataIndex: 'conType' }),
        XCol.Create({ col: 5,  text: 'Ref. #', width: 100, dataIndex: 'refNo' }),
        XCol.Create({ col: 6,  text: 'MBL #', width: 100, dataIndex: 'mblNo' }),
        XCol.Create({ col: 7,  text: 'HBL #', width: 100, dataIndex: 'hblNo' }),
        XCol.Create({ col: 8,  text: 'Customer', width: 150, dataIndex: 'customerName' }),
        XCol.Create({ col: 9,  text: 'RQ Date', width: 100, dataIndex: 'trDate', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center, visible: true }),
        XCol.Create({ col: 10, text: 'Container Tracking', width: 210, dataIndex: 'trStatus' }),
        XCol.Create({ col: 11, text: 'Container Dispatched', width: 115, dataIndex: 'ord', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 12, text: 'Gate In', width: 100, dataIndex: 'inDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 13, text: 'Load on Vessel', width: 100, dataIndex: 'loadDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 14, text: 'Vessel Departure', width: 100, dataIndex: 'atd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 15, text: 'Vessel Arrival', width: 100, dataIndex: 'ata', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 16, text: 'Unloaded Vessel', width: 100, dataIndex: 'unloadDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 17, text: 'Rail Departure', width: 100, dataIndex: 'rAtd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 18, text: 'Inland ETA', width: 100, dataIndex: 'inlandEta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 19, text: 'Rail Arrival', width: 100, dataIndex: 'rAta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 20, text: 'LFD', width: 100, dataIndex: 'lastFreeDay', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 21, text: 'Pickup Available', width: 100, dataIndex: 'puDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 22, text: 'Pickup Container', width: 100, dataIndex: 'outDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 23, text: 'Actual Delivery', width: 100, dataIndex: 'dcDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 24, text: 'Empty CNTR Return', width: 100, dataIndex: 'emptyReturn', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 25, text: 'ETD', width: 75, dataIndex: 'etd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 26,  text: 'ETA', width: 75, dataIndex: 'eta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 27,  text: 'Loading Port', width: 100, dataIndex: 'loadingPort' }),
        XCol.Create({ col: 28,  text: 'Discharge Port', width: 100, dataIndex: 'dischargePort' }),
        XCol.Create({ col: 29,  text: 'Place of Delivery', width: 100, dataIndex: 'placeOfDelivery' }),
        XCol.Create({ col: 30, text: 'Location', width: 80, dataIndex: 'location'}),
        XCol.Create({ col: 31, text: 'Vessel', width: 120, dataIndex: 'vessel' }),
        XCol.Create({ col: 32, text: 'Voyage', width: 120, dataIndex: 'voyage' }),
        // XCol.Create({ col: 14, text: 'Booking', width: 80, dataIndex: 'bookingDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 33, text: 'Create', width: 75, dataIndex: 'mblCreatedDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 34, text: 'Create By', width: 75, dataIndex: 'mblCreateBy' }),
        XCol.Create({ col: 35, text: 'RQ By', width: 75, dataIndex: 'trCreatedBy' }),
    ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };

    public static OrderBy = { orderBy: OtOpContainerListItem.prototype.id, orderByAscending: false };

    public static formatData(data: OtOpContainerListItem[]) {
        return data.map((d: OtOpContainerListItem) => ({
            ...d,
        }));
    }

    public static MapSearchFields: { [key: string]: { [key: string]: string } } = {
        eta: { from: 'fromEta', to: 'toEta' },
        bookingDate: { from: 'fromBookingDate', to: 'toBookingDate' },
        ord: { from: 'fromOrd', to: 'toOrd' },
        inDate: { from: 'fromInDate', to: 'toInDate' },
        loadDate: { from: 'fromLoadDate', to: 'toLoadDate' },
        atd: { from: 'fromAtd', to: 'toAtd' },
        ata: { from: 'fromAta', to: 'toAta' },
        unloadDate: { from: 'fromUnloadDate', to: 'toUnloadDate' },
        carrierRls: { from: 'fromCarrierRls', to: 'toCarrierRls' },
        customRls: { from: 'fromCustomRls', to: 'toCustomRls' },
        rAtd: { from: 'fromRAtd', to: 'toRAtd' },
        inlandEta: { from: 'fromInlandEta', to: 'toInlandEta' },
        rAta: { from: 'fromRAta', to: 'toRAta' },
        lastFreeDay: { from: 'fromLastFreeDay', to: 'toLastFreeDay' },
        puDate: { from: 'fromPuDate', to: 'toPuDate' },
        outDate: { from: 'fromOutDate', to: 'toOutDate' },
        dcDate: { from: 'fromDcDate', to: 'toDcDate' },
        emptyReturn: { from: 'fromEmptyReturn', to: 'toEmptyReturn' },
        etd: { from: 'fromEtd', to: 'toEtd' },
        trDate: { from: 'fromTrDate', to: 'toTrDate' },
        mblCreatedDate: { from: 'frommblCreatedDate', to: 'tomblCreatedDate' },
        confirmDate: {from: 'fromConfirmDate', to: 'toConfirmDate'},
    };
}
